const MANILA_OFFSET_MS = 8 * 60 * 60 * 1000;
const DAY_MS = 24 * 60 * 60 * 1000;

/** Posting/detail boundary for [rfq.deadline](../../../docs/product/rfqs.md#rfq-deadline): a real ISO date ends at the next
 * Manila midnight. Unknown historical text has no inferred deadline.
 * The server independently validates publication and locked offer submission.
 */
export function rfqDeadlineExpired(deadline: string | null | undefined, now = Date.now()): boolean {
  if (!deadline || !/^\d{4}-\d{2}-\d{2}$/.test(deadline)) return false;
  const [year, month, day] = deadline.split("-").map(Number);
  if (year < 1000) return false;
  const calendar = new Date(Date.UTC(year, month - 1, day));
  if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day) return false;
  return now >= calendar.getTime() - MANILA_OFFSET_MS + DAY_MS;
}
